/* prettier-ignore */

import { Component, ElementRef, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from '../../services/rest.service';
import { ToolsService } from 'src/app/services/tools.service';
import { Loader } from "@googlemaps/js-api-loader"
declare var google: any;

@Component({
  selector: 'cicerone-google-maps-places',
  standalone: true,
  templateUrl: './google-maps-places.component.html',
  styleUrls: ['./google-maps-places.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class GoogleMapsPlacesComponent {
    @ViewChild('inputStreet', { static: true }) inputStreet?: ElementRef;
    @Output() public locationForm = new EventEmitter();

    constructor(public modalCtrl: ModalController, public translate: TranslateService, private rest: RestService, private tools: ToolsService) {}

    ngAfterViewInit(){
        const input = this.inputStreet.nativeElement;
        if (input){
            input.placeholder = this.translate.instant('Introduce una ubicación');
            const center = this.rest.device.location;
            const limits = this.rest.device?.location?.searchRadius;
            // const defaultBounds = { north: center.latitude + 0.5, south: center.latitude - 0.5, east: center.longitude + 0.5, west: center.longitude - 0.5 };
            // const options = { bounds: defaultBounds, strictBounds: false, types: [], componentRestrictions: {country: ['es', 'and', 'br', 'ar'] } };
            const defaultBounds = { north: center.latitude + limits, south: center.latitude - limits, east: center.longitude + limits, west: center.longitude - limits };
            const options = { bounds: defaultBounds, strictBounds: limits !== 0, types: [], componentRestrictions: {country: ['es', 'and', 'br', 'ar'] } };

            const loader = new Loader({
                apiKey: "AIzaSyCosmIo9py_6Dfd_mr1CWSJxQtDzl1LWjA",
                version: "weekly",
                libraries: ["geometry", "places"]
            });
            
            loader.load().then(async () => {
                const { Autocomplete } = await google.maps.importLibrary("places") as google.maps.PlacesLibrary;
                const searchBox = new Autocomplete(input, options);     
                searchBox?.addListener('place_changed', async () => {
                    const place = searchBox.getPlace();
                    const location = await this.getLocation(place);
                    this.locationForm.emit(location);
                    input.focus();
                });
            });
        }
    }

    getLocation(place: any): Promise<any> {
        return new Promise((resolve, reject) => {
            if (place && place.geometry && place.geometry.location) {
                const latitudeForm = place.geometry.location.lat();
                const longitudeForm = place.geometry.location.lng();
                const location = { 'latitude': latitudeForm, 'longitude': longitudeForm, 'name': place.name };
                resolve(location);
            } else {
                reject(new Error('No se pudo obtener la geolocalización del lugar seleccionado.'));
            }
        });
    }

    focusin(evt) {
        evt.stopPropagation();
    }

}